var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTableSanction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52197 14.4928V15.9928H0.521973V14.4928H9.52197ZM9.96147 0.00726318L15.795 5.84076L14.7345 6.90276L13.9395 6.63726L12.0817 8.49276L16.3245 12.7355L15.264 13.796L11.022 9.55326L9.21897 11.3563L9.43122 12.2053L8.36997 13.2658L2.53647 7.43226L3.59772 6.37176L4.44522 6.58326L9.16572 1.86351L8.90097 1.06851L9.96147 0.00726318Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableSanction);
export default __webpack_public_path__ + "static/media/icon_table_sanction.35b79753066cd35c60c144a3977ca06a.svg";
export { ForwardRef as ReactComponent };